// How a customer wants to receive packages. Mirrors legacy-api
// common/utils/delivery-preference.js.
//
// CourierUser.deliveryPreference defaults to 'delivery' for everyone, so only
// a customer with deliveryPreferenceSetAt has actually chosen. A retired
// 'both' (never offered by any UI) reads as 'delivery'.
export const DELIVERY_PREFERENCES = ['delivery', 'pickup', 'call_first'] as const;

export type DeliveryPreference = (typeof DELIVERY_PREFERENCES)[number];

interface DeliveryPreferenceSource {
  deliveryPreference?: string | null;
  deliveryPreferenceSetAt?: Date | string | null;
}

/** The customer's chosen preference, or null when they never chose one. */
export function effectiveDeliveryPreference(
  user: DeliveryPreferenceSource | null | undefined
): DeliveryPreference | null {
  if (!user?.deliveryPreferenceSetAt) return null;
  const value = user.deliveryPreference as DeliveryPreference;
  return DELIVERY_PREFERENCES.includes(value) ? value : 'delivery';
}
